import type { FaireProductEntity } from "../../entity_types/product";

export const p_72tyczraz9: FaireProductEntity = {
  token: "p_72tyczraz9",
  type: "product",
  name: "Cuatro Tetas Basket - Straw Raffia Home Decor & Storage",
  brandToken: "b_rz9qg9uuan",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/2f4218de153a4582d545e9c9209df51a3803cc71756c158256a65bcf660095d4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4eab4d53fd15354279d9e7547ccdcb0dacaa6f6cf67908085bfc008ba79c564d.png",
    "https://cdn.faire.com/fastly/8bda8535e0f7cf22fb5bd8d9193e248cf9bed9e28b6ce20a23e554e880e28db2.png",
  ],
  priceDollars: 94.5,
  description:
    'Bring your home decor to the next level! \n\nStunning and unique, this handwoven basket called ""Cuatro Tetas"" is made by Eperara artisans from the south of Colombia. Using a traditional weaving technique from the region, they are sturdy yet lightweight - a work of art that will bring the ultimate touch of boho chic to your home or your summer fashion outfits.\n\nIt is 100% made of tetera straw, handmade and will leave no trace in the environment. By buying this item, you are helping the women artisans to keep their traditions alive and finance a way for them to have a better life. \n\nAll of our items are 100% handmade from natural fibers. Please allow for any color and sizing variations, or natural imperfections created during the hand making process.\n\n\nSIZES (height):\n\nXS: 30cm / 11.5"\n\nS: 38cm / 14.7"\n\nM: 52cm / 20"\n\nL: 76cm / 29.8"\n\nXL: 100cm / 39"\n\nFollow us --- https://instagram.com/corocoracolombia/\n\nThank you for your support :)',
  tags: [],
  msrpDollars: 189,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.103Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
